import { List as ImmutableList, Map as ImmutableMap, OrderedMap as ImmutableOrderedMap } from 'immutable';

export {
  Collection as ImmutableCollection,
  isList,
  List as ImmutableList,
  Map as ImmutableMap,
  Range as ImmutableRange,
  Repeat as ImmutableRepeat,
  Set as ImmutableSet,
} from 'immutable';

export const uniq = <T, K>(list: ImmutableList<T>, fn?: (item: T) => K): ImmutableList<T> => {
  return ImmutableOrderedMap(list.map((item) => [fn ? fn(item) : item, item])).toList();
};

export const compact = <T>(list: ImmutableList<T | undefined | null>) => {
  return list.filter(Boolean) as ImmutableList<T>;
};

export const partition = <T>(list: ImmutableList<T>, fn: (t: T) => unknown) => {
  return list.reduce<[ImmutableList<T>, ImmutableList<T>]>(
    ([left, right], value) => (fn(value) ? [left.push(value), right] : [left, right.push(value)]),
    [ImmutableList(), ImmutableList()],
  );
};

// can be used in a `.then` from a supabase call to organize the data into a map
export const groupBy = <T extends object, K extends keyof T & string>(items: T[], key: K) => {
  return items.reduce((acc, item) => {
    const keyValue = item[key]; // 'id' for example
    if (typeof keyValue !== 'string') throw new Error('Key must be a string');

    return acc.update(keyValue, [], (arr) => arr.concat(item));
  }, ImmutableMap<string, T[]>());
};
